import { FC } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";

type Option = { value: string | number; label: string | number };

type Props = {
  name?: string;
  control?: any;
  options: Option[];
  placeholder?: string;
  onChange?: (data: any) => void;
  value?: any;
  defaultValue?: any;
  className?: string;
  disabled?: boolean;
  isMulti?: boolean;
};

const SelectField: FC<Props> = ({
  control,
  name,
  options,
  placeholder,
  onChange,
  value,
  defaultValue,
  className,
  disabled = false,
  isMulti = false,
}) => {
  const findValue = (val: any) => {
    if (isMulti && Array.isArray(val)) {
      return options.filter((option) => val.includes(option.value));
    }
    return options.find((option) => option.value === val);
  };

  return control && name ? (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const selectedValue = findValue(field.value);

        return (
          <Select
            isDisabled={disabled}
            isMulti={isMulti}
            {...field}
            options={options}
            className="react-select-container"
            classNamePrefix="react-select"
            placeholder={placeholder ?? "Select"}
            value={selectedValue}
            onChange={(selectedOption: any) => {
              const valueToSet = isMulti
                ? selectedOption?.map((opt: any) => opt.value) ?? []
                : selectedOption?.value ?? null;

              field.onChange(valueToSet);
              onChange?.(valueToSet);
            }}
            classNames={{
              control: () => `py-1 shadow ${className}`,
            }}
            styles={{
              control: (base) => ({
                ...base,
                borderRadius: "0.5rem",
              }),
            }}
            defaultValue={findValue(defaultValue)}
          />
        );
      }}
    />
  ) : (
    <Select
      isDisabled={disabled}
      isMulti={isMulti}
      options={options}
      className="react-select-container"
      classNamePrefix="react-select"
      placeholder={placeholder ?? "Select"}
      value={findValue(value)}
      onChange={(selectedOption: any) => {
        const valueToSet = isMulti
          ? selectedOption?.map((opt: any) => opt.value) ?? []
          : selectedOption?.value ?? null;

        onChange?.(valueToSet);
      }}
      classNames={{
        control: () => `py-1 shadow ${className}`,
      }}
      styles={{
        control: (base) => ({
          ...base,
          borderRadius: "0.5rem",
        }),
      }}
      defaultValue={findValue(defaultValue)}
    />
  );
};

export default SelectField;

// import { FC } from "react"
// import { Controller } from "react-hook-form"
// import Select from "react-select"

// type Props = {
//     name?: string;
//     control?: any,
//     options: Array<{ value: string|number, label: string|number }>
//     placeholder?: string;
//     onChange?: (data: any) => void;
//     value?: any;
//     defaultValue?: any;
//     className?: string;
//     disabled?: boolean;
// }

// const SelectField: FC<Props> = (
//     { control, name, options, placeholder, onChange, value, className, defaultValue, disabled = false }
// ) => {
//     return (
//         control && name
//         ?
//             <Controller
//                 name={name || ""}
//                 control={control}
//                 render={({ field }) => (
//                     <Select
//                         isDisabled={disabled}
//                         {...field}
//                         options={options}
//                         className="react-select-container"
//                         classNamePrefix="react-select"
//                         placeholder={placeholder ?? "Select"}
//                         value={options.find(option => option.value === field.value)}
//                         onChange={
//                             (selectedOption) => {
//                                 field.onChange(selectedOption?.value)
//                                 onChange && onChange(selectedOption?.value);
//                             }
//                         }
//                         classNames={{
//                             control: () => `py-1 shadow ${className}`,
//                         }}
//                         styles={{
//                             control: (base) => ({
//                                 ...base,
//                                 borderRadius: '0.5rem',
//                             })
//                         }}
//                         defaultValue={
//                             typeof defaultValue == "object"
//                                 ? defaultValue
//                                 : options.find(op => op.value == defaultValue)
//                         }
//                     />
//                 )}
//             />
//         :
//             <Select
//                 options={options}
//                 className="react-select-container"
//                 classNamePrefix="react-select"
//                 placeholder={placeholder ?? "Select"}
//                 value={options.find(option => option.value === value)}
//                 onChange={
//                     (selectedOption) => {
//                         onChange && onChange(selectedOption?.value);
//                     }
//                 }
//                 classNames={{
//                     control: () => `py-1 shadow ${className}`,
//                 }}
//                 styles={{
//                     control: (base) => ({
//                         ...base,
//                         borderRadius: '0.5rem',
//                     })
//                 }}
//                 defaultValue={
//                     typeof defaultValue == "object"
//                         ? defaultValue
//                         : options.find(op => op.value == defaultValue)
//                 }
//             />
//     )
// }

// export default SelectField;
